import React from 'react';
import useOnlineStatus from '../hooks/useOnlineStatus';
import './OfflineBanner.css';

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="offline-banner">
      <span className="offline-icon">📡</span>
      <span className="offline-message">
        You are currently offline. Some features may not be available.
      </span>
    </div>
  );
};

export default OfflineBanner;
